package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_department


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("createDepartment")
    val createDepartment: CreateDepartment?,
    @SerialName("__typename")
    val typename: String?
)